import React from 'react';
import { Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';

const FolderBreadCrumbs = ({ currentFolder, path }) => {
  const parts = path.split("/").filter(part => part); 
    const role = localStorage.getItem("type");

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link to={`/${role}/docvault`} className='hover:underline'>
        Home
      </Link>
      {parts.map((part, index) => {
        const breadcrumbPath = `/${role}/docvault/${parts.slice(0, index + 1).join("/")}`;
        
        return index === parts.length - 1 ? (
          <span key={part} className='font-bold'>{currentFolder?.name || part}</span>  
        ) : (
          <Link key={part} to={breadcrumbPath} className='hover:underline'>
            {part}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default FolderBreadCrumbs;
